import { render } from "./WhiteOutlineButton.vue?vue&type=template&id=2e566032&scoped=true"
import script from "./WhiteOutlineButton.vue?vue&type=script&lang=js"
export * from "./WhiteOutlineButton.vue?vue&type=script&lang=js"

import "./WhiteOutlineButton.vue?vue&type=style&index=0&id=2e566032&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e566032"]])

export default __exports__